import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AlertTriangle, Info, X } from "lucide-react";

const STYLES = {
  info: { bg: "bg-[#1E3A8A]", border: "border-[#1E3A8A]", text: "text-white", icon: Info },
  warning: { bg: "bg-[#D97706]", border: "border-[#D97706]", text: "text-white", icon: AlertTriangle },
  danger: { bg: "bg-[#DC2626]", border: "border-[#DC2626]", text: "text-white", icon: AlertTriangle },
};

export default function AlertBanner() {
  const [alert, setAlert] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get("/alert").then((r) => setAlert(r.data)).catch(() => {});
  }, []);

  if (!alert || !alert.active || !alert.message || dismissed) return null;

  const s = STYLES[alert.type] || STYLES.warning;
  const Icon = s.icon;

  return (
    <div className={`${s.bg} ${s.text} relative`} data-testid="alert-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center gap-3">
        <Icon size={18} className="shrink-0" />
        <p className="text-sm font-semibold flex-1 leading-snug">{alert.message}</p>
        <button
          onClick={() => setDismissed(true)}
          className="shrink-0 p-1 rounded hover:bg-white/20 transition-colors"
          aria-label="Fermer"
          data-testid="alert-dismiss"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
